$shm_hitalama_map_widget_float_customizer $shm_hitalama_map_widget_float
	controls /
		<= Controls $mol_list
			sub /
				<= Head $mol_view
					sub /
						<= Deck_switch
						<= Name $mol_string
							value? <=> title? \
						<= Visible $mol_check_box
							title \Отображать в меню
							checked? <=> visible_in_menu? false
							- value? <=> title? \
						- <= Base $mol_select
							value? <=> base_type? \$mol_view
						<= Create $mol_button_major
							title \Создать
							click? <=> create_instance? null
				<= Deck_content
	Deck $mol_deck
		Switch => Deck_switch
		Content => Deck_content
		current? <=> soure_type_current? \0
		items /
			<= View_tree $mol_textarea
				title \View
				sidebar_showed true
				value? <=> code_view_tree? \
			<= Css $mol_textarea
				title \Style
				sidebar_showed true
				value? <=> code_css? \
			<= Js $mol_textarea
				title \Logic
				sidebar_showed true
				value? <=> code_js? \
	attr *
		^
		mol_theme \$mol_theme_special
